import localeAntd from 'antd/es/locale/es_ES'
import messages from './es.json'
import newlabels from './es_new.json'
import enlabels from './en_new.json'

export default {
  locale: 'es-ES',
  localeAntd,
  messages: {
    ...messages,
    ...enlabels,
    ...newlabels
  }
}
